import React from "react";
import '../../assets/css/buttons/NormalSizeCloseBtn.css';

const NormalSizeCloseBtn = ({setFalseArr, isMergeAccount}) => {
    return (
        <div className='closeButton flex flexCenter'>
            <button type="button" onClick={() => {
                    if(setFalseArr){
                        setFalseArr.forEach(setFalse => {
                            setFalse(false);
                        })
                    }
                    if (isMergeAccount) {
                        window.history.back();
                    }
                }} className="NormalSizeCloseBtn">
                <div className="closeBtn--innerBorder flex flexJustifyEnd">
                    &times;
                </div>
            </button>
        </div>
    );
}

export default NormalSizeCloseBtn;